import {
  CAYMAN_REGION,
  mapCaymanDistrictRegion,
} from '@/constants/tenant-configs/cayman';

import { Option } from '@/types/components/common';

export function getCaymanDistrictOptions(region = ''): Option[] {
  if (!region) {
    return [];
  }
  const districts = mapCaymanDistrictRegion[region];
  if (!districts) {
    return [];
  }
  return districts.map(district => ({
    text: district,
    value: district,
  }));
}

export function getCaymanRegionByDistrict({
  city = '',
  poBoxDistrict = '',
}: {
  city?: string;
  poBoxDistrict?: string;
}): string | undefined {
  for (const [region, districts] of Object.entries(mapCaymanDistrictRegion)) {
    if (districts.includes(city) || districts.includes(poBoxDistrict)) {
      return region;
    }
  }
  return undefined;
}

export function getValidValue({
  value1 = '',
  value2 = '',
  options,
}: {
  value1?: string;
  value2?: string;
  options: Option[];
}): string {
  let found = options.find(option => option.value === value1);
  if (!found) {
    found = options.find(option => option.value === value2);
  }
  return String(found?.value ?? '');
}

export function getValidRegion(
  region = '',
  defaultRegion = CAYMAN_REGION.GRAND_CAYMAN,
) {
  return Object.values(CAYMAN_REGION).includes(region) ? region : defaultRegion;
}
